import { render } from "./CommonIncrementInput.vue?vue&type=template&id=5c455fc4"
import script from "./CommonIncrementInput.vue?vue&type=script&lang=js"
export * from "./CommonIncrementInput.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\payroll-system\\dashboards\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__